import { atom } from 'jotai';

export type BuilderVariationPayload = Record<string, unknown> & {
  registrationSelectorConfig?: { hasDCB?: boolean; [key: string]: unknown };
  smsModalConfig?: Record<string, unknown>;
  urlConfig?: { hasDCB?: boolean; [key: string]: unknown };
};

export type ConfigState = Record<string, BuilderVariationPayload>;

const initialState: ConfigState = {};

export const configAtom = atom<ConfigState>(initialState);
